// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2IwXW","select":"Header_select__T5tHx","clinic":"Header_clinic__otEtO"};